const validation = {
  name: { required: 'This field is required' },
};

export default validation;
